// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__GEUz4","container":"Hero_container__UHzFo","content":"Hero_content__5U4Ly","heading":"Hero_heading__m3DOG","text":"Hero_text__fnuLo","image":"Hero_image__SrP1V"};